import type { FaireThemeEntity } from "../../entity_types/theme";

export const tarnish_free_daily_luxe: FaireThemeEntity = {
  token: "tarnish-free-daily-luxe",
  type: "theme",
  name: "Tarnish-Free Daily Luxe",
  description: "Water-resistant and hypoallergenic jewelry designed for the busy client. These durable pieces stay gold through spa treatments and daily wear.",
  teaser: "As a beauty lounge, your patrons likely value products that are skin-safe and low-maintenance. These stainless steel-based items are perfect for a spa environment.",
  detail: "The context payload features products like the Evereign Knot Necklace and Éclaire Station Chain, which are explicitly described as non-tarnish, water-resistant, and hypoallergenic.",
  bgColor: "#D4D4FF",
  tileBgColor: "#6b5831",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_7rhv8snb8e",
    "p_74fkr8pvnd",
    "p_9pm84vbjg7",
    "p_jwba8zf33g",
    "p_5gefr7p29d",
    "p_ut3tbs6mrw",
    "p_nrg5hxcuy3",
    "p_hn7pzs5g4a",
    "p_wsaxm8rq23",
    "p_nryc8h2rjs",
    "p_85zuvdfqvw",
    "p_mfzddjcp7d",
    "p_xh2ydbj634",
    "p_q7hp7459nh",
    "p_2e2hpd7fg4",
    "p_bagjhpjgk4",
    "p_ar6ja253qt",
    "p_s7mxah3gtv",
    "p_ykcapkuvqq",
    "p_9r88u99ph7",
    "p_495zgeetkv",
    "p_pxyfdb9fc3",
    "p_zbfwgazcex",
    "p_jhcrb92fnq",
    "p_s5kj5vxsjg",
    "p_sejqps7khh",
    "p_vdu7gwva43",
    "p_5mcrgjwe7w",
    "p_7aj8n8fwkr",
    "p_ufjavmwa64",
    "p_mrdc3wmdh2",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
